import { env } from '../env';
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ReplyIcon from "@mui/icons-material/Reply";
import Tooltip from "@mui/material/Tooltip";
import stepperNav from "./stepperNav";

export default function HeaderBar({ title, page, setPage }) {
    document.title = env.REACT_APP_TITLE + " - " + title;

    const handleStepClick = () => {
        const index = page.page - 1;
        stepperNav(index, page, setPage);
    };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
                  <Button color="titleButton">{env.REACT_APP_TITLE}</Button>
          <Typography
            align="center"
            variant="h6"
            component="div"
                      sx={{ flexGrow: 1 }}
                  >{title}
                      </Typography>
                  <Button>{env.REACT_APP_TITLE}</Button>
                  {page.page > 0 ? (
                      <Tooltip title="Retour">
                          <IconButton
                              aria-label="backward"
                              size="medium"
                              onClick={handleStepClick}
                              color="titleButton">
                              <ReplyIcon />
                          </IconButton>
                      </Tooltip>
                  ) : (
                          <Typography></Typography>
                  )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
